import React from 'react';
import { motion } from 'framer-motion';
import { Divide as LucideIcon } from 'lucide-react';

interface ServiceCardProps {
  icon: typeof LucideIcon;
  title: string;
  description: string;
}

const ServiceCard: React.FC<ServiceCardProps> = ({ icon: Icon, title, description }) => {
  return (
    <motion.div
      whileHover={{ y: -6, transition: { duration: 0.25 } }}
      className="group bg-white p-7 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 h-full flex flex-col border border-gray-100 hover:border-navy-100"
    >
      <div className="bg-navy-50 group-hover:bg-orange-50 w-16 h-16 rounded-xl flex items-center justify-center mb-5 transition-colors duration-300">
        <Icon size={28} className="text-navy-600 group-hover:text-orange-500 transition-colors duration-300" />
      </div>
      <h3 className="text-xl font-semibold mb-3 text-navy-800">{title}</h3>
      <p className="text-navy-700 flex-grow leading-relaxed">{description}</p>
      <a
        href="/services"
        className="mt-5 inline-flex items-center text-navy-600 group-hover:text-orange-500 font-medium transition-colors"
      >
        Meer informatie
        <svg
          className="w-4 h-4 ml-1 transition-transform group-hover:translate-x-1"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5l7 7-7 7"
          />
        </svg>
      </a>
    </motion.div>
  );
};

export default ServiceCard;
